define([
    "jquery",
    "underscore",
    "marionette",
    "behaviors/datatables_behavior"
], function($, _, Marionette, DatatablesBehavior){
    return Marionette.LayoutView.extend({
        el: '#content_layout',

        behaviors: {
            datatables: {
                behaviorClass: DatatablesBehavior
            }
        },

        ui: {
            'paginateButton': '.paginate_button'
        },

        regions: {

        },
        events: {
            'click @ui.paginateButton': function (e){
                if(e) e.preventDefault();

                const pageInput = document.getElementById("page");
                console.log(e.currentTarget.firstChild.innerText)
                pageInput.value = e.currentTarget.firstChild.innerText;
            }
        },

        initialize: function(){

            this.bindUIElements();

            // We init the datatable
            this.triggerMethod('init:table', {
                url: '/rest_payout/history',
                order: [[ 0, "desc" ]],
                columns: [
                    {
                        'name':'reg_datetime',
                        'data':'reg_datetime',
                        'type': 'date'
                    },
                    {
                        'name':'amount',
                        'data':'amount'
                    },
                    {
                        'name':'type',
                        'data':'type_trans'

                    },
                    {
                        'name':'pay_method',
                        'data':'pay_method_trans'
                    },
                    {
                        'name':'status',
                        'data':'status_trans'
                    }
                ]
            });
        }
    });
});
